// Product component
import { Button, ArrowLeftIcon } from '@ag1/ui';
import { useProductStore } from '@portal/state/store/pdpStore';
import { useRouter } from 'next/router';
import { Breadcrumbs as BreadcrumbsProps, SanityKeyed } from 'types/studio/studio';
import { routes } from 'constants/routes';
import styles from './Breadcrumbs.module.scss';
import { CommonSectionProps } from '../../types';

const Breadcrumbs = ({ showBreadcrumbs }: SanityKeyed<BreadcrumbsProps> & CommonSectionProps) => {
  const router = useRouter();

  const productCategory = useProductStore((state) => state.selectedPdpProductCategory);
  const productTitle = useProductStore((state) => state.selectedPdpProductTitle);

  const handleBack = () => {
    if (router.back() !== undefined) {
      router.back();
    } else {
      router.push(routes.shopPlp);
    }
  };

  if (!showBreadcrumbs) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Button
        variant="link"
        className={styles.backLink}
        noPadding
        icon={<ArrowLeftIcon className={styles.arrowLeftIcon} size={32} />}
        onClick={handleBack}>
        {`${productCategory}`}
      </Button>
      <span className={styles.crumbDivider}>/</span>
      <div className={styles.productLink}>{`${productTitle}`}</div>
    </div>
  );
};

export default Breadcrumbs;
